import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#dcb439",
            contrastText: "white"
        }
    },
    components: {
        MuiTextField: {
            defaultProps: {
                size: "small",
                margin: "dense"
            }
        },
        MuiSelect: {
            defaultProps: {
                size: "small"
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained"
            }
        }
    },
});

export default theme;
